export type ReferralShareResult = 'shared' | 'copied' | 'cancelled' | 'failed';

/** Call directly from a click handler so Web Share keeps its user activation. */
export async function shareReferralLink(link: string): Promise<ReferralShareResult> {
  if (!/^https?:\/\//i.test(link)) return 'failed';
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ url: link });
      return 'shared';
    } catch (error) {
      if (error && typeof error === 'object' && 'name' in error && error.name === 'AbortError') return 'cancelled';
    }
  }
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(link);
    } else {
      const area = document.createElement('textarea');
      area.value = link;
      area.readOnly = true;
      area.style.position = 'fixed';
      area.style.left = '-9999px';
      document.body.appendChild(area);
      area.select();
      const copied = document.execCommand('copy');
      area.remove();
      if (!copied) return 'failed';
    }
    return 'copied';
  } catch {
    return 'failed';
  }
}
